module.exports = "/_next/static/images/71342deb073c93513ed1ae7e29fdfd92-get-earnings.png.webp";